var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('viewer',{staticClass:"img-list"},_vm._l((_vm.imgList),function(item,index){return _c('div',{key:index,staticClass:"img-list-li"},[_c('img',{attrs:{"src":item.url}})])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }